function initializeCrossborderModal ({
    modalQuerySelector = '#crossborder-modal',
    continueButtonQuerySelector = '.crossborder-store-continue-button',
    storeNameQuerySelector = '.crossborder-store-name',
} = {}) {

    const crossborderModal = document.querySelector(modalQuerySelector);
    const continueButton = crossborderModal.querySelector(continueButtonQuerySelector);
    const storeNameSpan = continueButton.querySelector(storeNameQuerySelector);

    crossborderModal.addEventListener('show.bs.modal', (event) => {
        const crossborderShopNowButton = event.relatedTarget;
        const crossborderRedirectUrlAttribute = crossborderShopNowButton.dataset.crossborderRedirectUrl;
        const crossborderStoreNameAttribute = crossborderShopNowButton.dataset.crossborderStoreName;

        continueButton.href = crossborderRedirectUrlAttribute;
        if(storeNameSpan){
            storeNameSpan.innerText = crossborderStoreNameAttribute;
        }

    })
    crossborderModal.addEventListener('hidden.bs.modal', (event) => {
        continueButton.href = '';
        if(storeNameSpan){
            storeNameSpan.innerText = '';
        }
    })
};

initializeCrossborderModal();
